// src/pages/HistoricoPedidos.jsx
import React, { useContext, useEffect } from 'react';
import styles from './HistoricoPedido.module.css';
import { PedidosContext } from '../../../shared/contexts/PedidosContext';
import { ItensPedidosContext } from '../../../shared/contexts/ItensPedidosContext';
import CardUltimosPedidos from '../../../shared/components/CardUltimosPedidos';
import FooterOpcoes from '../components/FooterOpcoes';
import HeaderPagesMobile from '../../../shared/components/HeaderPagesMobile';

// Histórico de pedidos do cliente logado — pedidos já finalizados (entregues
// ou cancelados), diferente de /pedidoscliente que foca no pedido em
// andamento. Usa o mesmo PedidosContext (SSE + polling) então fica
// sempre atualizado.
function HistoricoPedidos() {
  const { pedidos, loading, atualizarPedidos } = useContext(PedidosContext);
  const { atualizarItens } = useContext(ItensPedidosContext);

  useEffect(() => {
    atualizarPedidos();
    atualizarItens();
  }, []);

  const idClienteLogado = localStorage.getItem('id_cliente');

  const historico = pedidos
    .filter((pedido) => String(pedido.id_cliente) === idClienteLogado)
    .filter((pedido) => ['entregue', 'cancelado'].includes(pedido.status?.trim().toLowerCase()))
    .sort((a, b) => new Date(b.data_pedido) - new Date(a.data_pedido));

  return (
    <div className={styles.historicoContainer}>
      <HeaderPagesMobile namePage="Histórico de Pedidos" />

      <main className={styles.historicoList}>
        {loading && <p>Carregando histórico...</p>}

        {!loading && historico.length === 0 && (
          <div className={styles.emptyState}>
            <p>Você ainda não tem pedidos finalizados.</p>
          </div>
        )}

        {!loading && historico.map((pedido) => (
          <CardUltimosPedidos
            key={pedido.id_pedido}
            pedido={pedido}
            typeView="cliente"
            mostrarBotoesStatus={false}
          />
        ))}
      </main>

      <FooterOpcoes typeView="cliente" />
    </div>
  );
}

export default HistoricoPedidos;
